import { defineComponent as _defineComponent } from 'vue'
import { unref as _unref, toDisplayString as _toDisplayString, createElementVNode as _createElementVNode, createTextVNode as _createTextVNode, openBlock as _openBlock, createElementBlock as _createElementBlock, createCommentVNode as _createCommentVNode } from "vue"
import _imports_0 from '../../../assets/images/welcome/investidor.png'


const _hoisted_1 = { class: "card mb-25 border-0 rounded-0 welcome-box" }
const _hoisted_2 = { class: "card-body pe-15 pe-sm-20 pe-md-0 pb-0 pt-15 pt-sm-20" }
const _hoisted_3 = { class: "row align-items-center" }
const _hoisted_4 = { class: "col-lg-6 col-md-6" }
const _hoisted_5 = { class: "title position-relative" }
const _hoisted_6 = { class: "fw-semibold mb-8" }
const _hoisted_7 = { class: "fw-bold" }
const _hoisted_8 = /*#__PURE__*/_createElementVNode("span", { class: "d-block text-black-emphasis fs-md-15 fs-lg-16" }, " Aqui está o que está acontecendo agora ", -1)
const _hoisted_9 = {
  key: 0,
  class: "ps-0 mb-0 list-unstyled"
}
const _hoisted_10 = /*#__PURE__*/_createElementVNode("li", { class: "d-inline-block text-uppercase fw-medium fs-13 text-black-emphasis position-relative" }, " Atualizando... ", -1)
const _hoisted_11 = [
  _hoisted_10
]
const _hoisted_12 = {
  key: 1,
  class: "ps-0 mb-0 list-unstyled"
}
const _hoisted_13 = { class: "d-inline-block text-uppercase fw-medium fs-13 text-black-emphasis position-relative" }
const _hoisted_14 = { class: "d-block fw-black lh-1 text-black mt-5 mt-md-10" }
const _hoisted_15 = { class: "d-inline-block text-uppercase fw-medium fs-13 text-black-emphasis position-relative" }
const _hoisted_16 = { class: "d-block fw-black lh-1 text-black mt-5 mt-md-10" }
const _hoisted_17 = { class: "d-inline-block text-uppercase fw-medium fs-13 text-black-emphasis position-relative" }
const _hoisted_18 = { class: "d-block fw-black lh-1 text-black mt-5 mt-md-10" }
const _hoisted_19 = /*#__PURE__*/_createElementVNode("div", { class: "col-lg-6 col-md-6 text-center mt-15 mt-md-0" }, [
  /*#__PURE__*/_createElementVNode("img", {
    src: _imports_0,
    alt: "welcome-image"
  })
], -1)

import { getUser, f2dec } from '@/utils/funcoes'; 
  import { onMounted, reactive } from 'vue';

  interface IProps {
    nomeUsuario: string,
    qtdeContratos: number,
    totalContratos: number,
    percInvestidor: number,
    atualizando: boolean
  }

  
export default /*#__PURE__*/_defineComponent({
  __name: 'WhatHappening',
  props: {
    nomeUsuario: {},
    qtdeContratos: {},
    totalContratos: {},
    percInvestidor: {},
    atualizando: { type: Boolean }
  },
  setup(__props: any) {


  var props = __props;

  const controle = reactive({
    usuario: {}
  });

  onMounted(()=> {
    controle.usuario = getUser() as any;
  })

return (_ctx: any,_cache: any) => {
  return (_openBlock(), _createElementBlock("div", _hoisted_1, [
    _createElementVNode("div", _hoisted_2, [
      _createElementVNode("div", _hoisted_3, [
        _createElementVNode("div", _hoisted_4, [
          _createElementVNode("div", _hoisted_5, [
            _createElementVNode("h3", _hoisted_6, [
              _createTextVNode(" Ola, "),
              _createElementVNode("span", _hoisted_7, _toDisplayString(_unref(props).nomeUsuario) + "!", 1)
            ]),
            _hoisted_8
          ]),
          (_unref(props).atualizando)
            ? (_openBlock(), _createElementBlock("ul", _hoisted_9, _hoisted_11))
            : _createCommentVNode("", true),
          (_unref(props).atualizando == false)
            ? (_openBlock(), _createElementBlock("ul", _hoisted_12, [
                _createElementVNode("li", _hoisted_13, [
                  _createTextVNode(" CONTRATOS "),
                  _createElementVNode("span", _hoisted_14, _toDisplayString(_unref(props).qtdeContratos), 1)
                ]),
                _createElementVNode("li", _hoisted_15, [
                  _createTextVNode(" TOTAL "),
                  _createElementVNode("span", _hoisted_16, " R$ " + _toDisplayString(_unref(f2dec)(_unref(props).totalContratos)), 1)
                ]),
                _createElementVNode("li", _hoisted_17, [
                  _createTextVNode(" LUCRO ESPERADO "),
                  _createElementVNode("span", _hoisted_18, " R$ " + _toDisplayString(_unref(f2dec)(_unref(props).totalContratos * _unref(props).percInvestidor / 100)), 1)
                ])
              ]))
            : _createCommentVNode("", true)
        ]),
        _hoisted_19
      ])
    ])
  ]))
}
}

})